import { render, staticRenderFns } from "./LMSUser.vue?vue&type=template&id=ded881d8&"
import script from "./LMSUser.vue?vue&type=script&lang=js&"
export * from "./LMSUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports